// Whole-day diff between `iso` and `now`. Returns 0 if iso is missing or
// in the future. Used for the "X zile" age badge on unresolved problems.
export function daysSince(iso: string | null | undefined, now: Date = new Date()): number {
    if (!iso) return 0;
    const then = new Date(iso);
    if (Number.isNaN(then.getTime())) return 0;
    const diffMs = now.getTime() - then.getTime();
    if (diffMs <= 0) return 0;
    return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}

// Romanian short form. Skips the formal "de" connector for >=20 since the
// audience here is internal operators and the tight badge readability
// outweighs strict grammar.
export function daysLabel(days: number): string {
    if (days <= 0) return 'azi';
    if (days === 1) return '1 zi';
    return `${days} zile`;
}

export type Urgency = 'fresh' | 'warning' | 'critical';

// Bucketing for the age badge — 1-2d stays calm, 3-7d nags, 8d+ shouts.
export function urgencyFor(days: number): Urgency {
    if (days >= 8) return 'critical';
    if (days >= 3) return 'warning';
    return 'fresh';
}

export const URGENCY_CLASSES: Record<Urgency, string> = {
    fresh: 'bg-yellow-200 text-yellow-900 dark:bg-yellow-500/20 dark:text-yellow-200',
    warning: 'bg-orange-200 text-orange-900 dark:bg-orange-500/25 dark:text-orange-200',
    critical: 'bg-red-200 text-red-900 dark:bg-red-500/25 dark:text-red-200',
};
